import strings from '../lang/strings'

const tbAnalystHeaders = [
  {
    name: strings.game_num,
    class: 'w-10',
  },
  {
    name: strings.end_date,
    class: 'w-12',
  },
  {
    name: strings.game_category,
    class: 'w-8',
  },
  {
    name: strings.title,
    class: 'w-50 text-line',
  },
  {
    name: strings.analyst_member,
    class: 'w-10',
  },
  {
    name: strings.price_p,
    class: 'w-10',
    divider: false
  },
]

export const tbGameHeaders = [
  {
    name: strings.game_num,
    class: 'w-10',
  },
  {
    name: strings.game_category,
    class: 'w-8',
  },
  {
    name: strings.buy_date,
    class: 'w-12',
  },
  {
    name: strings.team_vs,
    class: 'w-15',
  },
  {
    name: strings.title,
    class: 'w-35 text-line',
  },
  {
    name: strings.analyst_member,
    class: 'w-10',
  },
  {
    name: strings.price_p,
    class: 'w-10',
    divider: false
  },
]

export const tbBjHeaders = [
  {
    name: strings.tb_game_category,
    class: 'w-10',
  },
  {
    name : strings.tb_bj_name,
    class : 'w-10',
  },
  {
    name: strings.tb_game_date,
    class: 'w-15',
  },
  {
    name: strings.tb_title,
    class: 'w-45 text-line',
  },
  {
    name: strings.tb_upload_date,
    class: 'w-15',
  },
  {
    name: strings.tb_purchase_availability,
    class: 'w-15',
    divider: false
  },
]

export const tbDailyHeaders = [
  {
    name: strings.tb_round_info,
    class: 'w-10',
  },
  {
    name: strings.tb_analyst_member,
    class: 'w-10',
  },
  {
    name: strings.tb_game_date,
    class: 'w-15',
  },
  {
    name: strings.title,
    class: 'w-45 text-line',
  },
  {
    name: strings.tb_upload_date,
    class: 'w-15',
  },
  {
    name: strings.tb_price,
    class: 'w-15',
    divider: false
  },
]

export const tbBjEditHeaders = [
  {
    name: strings.tb_game_category,
    class: 'w-13',
  },
  {
    name: strings.tb_game_date,
    class: 'w-12',
  },
  {
    name: strings.title,
    class: 'w-53 text-line hover-text-accent-child',
  },
  {
    name: strings.tb_upload_date,
    class: 'w-12',
  },
  {
    name: '',
    class: 'td-my-game-edit',
    divider: false
  },
]


export const tbDailyEditHeaders = [
  {
    name: strings.tb_round_info,
    class: 'w-13',
  },
  {
    name: strings.tb_game_date,
    class: 'w-12',
  },
  {
    name: strings.title,
    class: 'w-41 text-line hover-text-accent-child',
  },
  {
    name: strings.tb_upload_date,
    class: 'w-12',
  },
  {
    name: strings.price_p,
    class: 'w-12',
  },
  {
    name: '',
    class: 'td-daily-edit',
    divider: false
  },
]

export const tbBjResultPageEditHeaders = [
  {
    name: strings.num,
    class: 'w-10',
  },
  {
    name: strings.buy_date,
    class: 'w-12',
  },
  {
    name: strings.title,
    class: 'w-36 text-line hover-text-accent-child',
  },
  {
    name: strings.bj,
    class: 'w-10',
  },
  {
    name: strings.tb_upload_date,
    class: 'w-12',
  },
  {
    name: strings.price_p,
    class: 'w-10',
  },

  {
    name: '',
    class: 'td-my-game-edit',
    divider: false
  },
]


export const tbAnalystEditHeaders = [
  {
    name: strings.game_num,
    class: 'w-10',
  },
  {
    name: strings.game_category,
    class: 'w-10',
  },
  {
    name: strings.buy_date,
    class: 'w-12',
  },
  {
    name: strings.title,
    class: 'w-38 text-line',
  },
  {
    name: strings.analyst_member,
    class: 'w-10',
  },
  {
    name: strings.price_p,
    class: 'w-10',
  },
  {
    name: '',
    class: 'td-my-pro-edit',
    divider: false
  },
]


export const tbMypageBjEditHeaders = [
  {
    name: strings.num,
    class: 'w-10',
  },
  {
    name: strings.buy_date,
    class: 'w-12',
  },
  {
    name: strings.title,
    class: 'w-58 text-line',
  },
  {
    name: strings.bj,
    class: 'w-10',
  },
  {
    name: strings.price_p,
    class: 'w-10',
  },
  {
    name: '',
    class: 'td-my-game-edit',
    divider: false
  },
]

export const tabInfo = {
  bjMyPageGameArticle : {
    title : strings.bj_game_article,
    cate : 45,
    header : tbBjEditHeaders,
    table_type : "bj",
    url : "/bj/bj_result",
  },
  bjMyPageDaily : {
    title : strings.daily_special,
    cate : 6,
    header : tbDailyEditHeaders,
    table_type : "daily",
    url : "/analyst/daily_detail"
  },
  bjGameArticle : {
    title : strings.bj_game_article,
    cate : 45,
    header : tbBjHeaders,
    table_type : "bj",
    url : "/bj/bj_result",
  },
  bjGameSpecial : {
    title : strings.bj_betting_special,
    cate : 45,
    betting : true,
    header : tbBjHeaders,
    table_type : "bj",
    url : "/bj/bj_result",
  },
  pmGame : {
    title : strings.pm_game,
    cate : 4,
    header : tbBjHeaders,
    table_type : "bj",
    url : "/bj/bj_result",
  },
  eveGame : {
    title : strings.eve_game,
    cate : 5,
    header : tbBjHeaders,
    table_type : "bj",
    url : "/bj/bj_result"
  },
  protoGame : {
    title : strings.proto_game_analyst,
    cate : 1,
    header : tbGameHeaders,
    table_type : "game",
    url : "/analyst/game_detail",
  },
  protoBetting : {
    title : strings.proto_betting,
    cate : 2,
    header: tbAnalystHeaders,
    table_type : "analyst",
    url : "/analyst/betting_detail"
  },
  protoVictory : {
    title : strings.proto_victory,
    cate : 3,
    header : tbAnalystHeaders,
    table_type : "analyst",
    url : "/analyst/victory_detail"
  },
  daily :  {
    title : strings.daily_special,
    customTitle: <div className={`daily-tab-name`}><div className={`hot-icon`}>HOT</div><div className={`background-highlight`}>{strings.daily_special}</div></div>,
    cate : 6,
    header : tbDailyHeaders,
    table_type : "daily",
    url : "/analyst/daily_detail"
  }
}

export default tbAnalystHeaders
